export default "__VITE_ASSET__86de2d92__"